// ** React Imports
import { useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
// ** Custom Hooks
import { useSkin } from "@hooks/useSkin";
import useJwt from "../auth/jwt/useJwt";
// ** Third Party Components
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useForm, Controller } from "react-hook-form";
// ** Actions
import { handleLogin } from "@store/authentication";
// ** Context
import { AbilityContext } from "@src/utility/context/Can";
// ** Custom Components
import InputPasswordToggle from "@components/input-password-toggle";
// ** Utils
import { getHomeRouteForLoggedInUser, ErrorToast } from "@utils";
import themeConfig from "../configs/themeConfig";
// ** Reactstrap Imports
import {
  Row,
  Col,
  Form,
  Input,
  Label,
  Button,
  CardText,
  CardTitle,
  Alert, NavItem, Nav, NavLink,
  FormFeedback,
} from "reactstrap";
// ** Styles
import "@styles/react/pages/page-authentication.scss";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { Spinner } from "reactstrap";
import { useEffect } from "react";
import axios from "axios";
//import logo from "@src/assets/images/logo/logo.png"
import { Sun, Moon } from "react-feather";
import { useSelector } from "react-redux";
import { useRef } from "react";
import classnames from "classnames";
import { useFooterType } from "@hooks/useFooterType";
import { getdefaultLogoPath } from "../utility/Utils";
import SpinnerComponent from "../@core/components/spinner/Fallback-spinner";

const config = useJwt.jwtConfig;

const Login = (props) => {
  const { footer } = props;
  // ** Hooks
  const { skin, setSkin } = useSkin();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(null);
  const [logo, setLogo] = useState(null);

  const ability = useContext(AbilityContext);
  const [loading, setLoading] = useState(false);
  const { filters } = useSelector((state) => state.datatable);
  const filterHold = useRef({});
  const { footerType, setFooterType } = useFooterType();

  const defaultValues = {
    password: "",
    // empId: "",
    loginEmail: ''

  };

  const SignupSchema = yup.object().shape({
    password: yup.string().min(8).required(),
    // empId: yup.string().required('Employee ID is required').matches(/^\S*$/, 'Remove spaces from Employee ID'),
    loginEmail: yup.string().email().required()

  })

  const {
    control,
    trigger,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues, resolver: yupResolver(SignupSchema) })

  const searchParams = new URLSearchParams(location.search);
  const group = searchParams.get("group") ?? window.location.hostname

  useEffect(() => {
    const token = searchParams.get("token");
    const route = searchParams.get("route");

    getLogo(group, token)
    if (token) {
      setLoader(true);
      axios
        .post(`${themeConfig.app.apiUrl}/auto-login`, { token: token })
        .then((res) => {
          if (res.data.valid) {
            setLoader(false);
            const { userData, access_token } = res.data;
            validToken(userData, access_token);
            navigate(route);
          } else {
            setLoader(false);
            toast((t) => <ErrorToast t={t} message={"Token is invalid"} />);
            navigate(route);
          }
        })
        .catch(({ response }) => {
          setLoader(false);
          toast((t) => <ErrorToast t={t} message={"something went wrong"} />);
        });
    }
  }, [location]);

  const getLogo = (subdomainFromUrl, token) => {
    setLoader(true);
    axios.get(`${themeConfig.app.apiUrl}/get-Logo?group=` + subdomainFromUrl, {
      token: token,
    })
      .then((res) => {
        setLogo(res.data);
      })
      .catch(({ response }) => {
        toast((t) => <ErrorToast t={t} message={"something went wrong"} />);
      }).finally(() => setLoader(false))
  };

  const onSubmit = (data) => {
    setLoading(true);
    setError(null);
    useJwt
      .login({
        // empId: data.empId,
        email: data.loginEmail,
        password: data.password,
        group: group,
      })
      .then((res) => {
        setLoading(false);
        if (res.data?.access_token) {
          const { userData, access_token } = res.data;
          validToken(userData, access_token);
          navigate(getHomeRouteForLoggedInUser(userData.user_role.name));
        }
      })
      .catch(({ response }) => {
        setLoading(false);
        setError(response.data.message);

        if (response.data.lockout_status === 0) {
          toast((t) => <ErrorToast t={t} message={response.data.message} />);
        }
      });
  };

  const validToken = (userData, access_token) => {
    const data = { ...userData };
    data[config.storageTokenKeyName] = access_token;
    ability.update(JSON.parse(userData.user_role.ability));
    dispatch(handleLogin(data));
  };

  const ThemeToggler = () => {
    filterHold.current =
      Object.keys(filterHold.current).length === 0
        ? filters
        : filterHold.current;
    if (skin === "dark") {
      return (
        <Sun
          className="ficon"
          color="#3e71f6"
          size={30}
          onClick={() => setSkin("light", filterHold.current, true)}
        />
      );
    } else {
      return (
        <Moon
          className="ficon"
          color="#fff"
          size={30}
          onClick={() => setSkin("dark", filterHold.current, true)}
        />
      );
    }
  };

  return (
    <>
      {!loader && logo ? (
        <div className="d-flex align-items-center m-auto auth-wrapper auth-cover">
          <Row className={`auth-inner m-0`}>
            <div className="brand-logo d-flex justify-content-between">
              <div></div>
              <div className="themeside">  <ThemeToggler /></div>
            </div>
            <Col
              className="d-flex align-items-center m-auto justify-content-center p-lg-3 p-md-2 p-sm-2"
              lg="4"
              md="8"
              sm="12"
            >
              <Col
                className={`box-shadow-1 px-xl-2 px-xl-0 m-auto' sm='6' md='8' lg='12'
              ${skin === "dark" ? "outlineblack" : "outlinewhite"}`}
                lg='12' sm='12'>
                <Col className='px-xl-2 mx-auto' sm='8' md='6' lg='12'>
                  <div className="text-center">
                    <Link to="/" onClick={(e) => e.preventDefault()}  >

                      <img
                        width={'200'} height={'100px'}
                        src={getdefaultLogoPath(logo?.path)}
                        className="object-fit-contain"
                        alt="Logo"
                      />


                    </Link>
                    {/* <CardTitle tag='h2' className='fw-bolder my-1 card-title text-dark font-large-1'>DMS LOGIN  </CardTitle> */}
                    <CardText className='mb-2'>Please sign-in to your account and start the adventure</CardText>
                  </div>
                  <Form className='auth-login-form mt-2' onSubmit={handleSubmit(onSubmit)}>
                    <div className='mb-1'>
                      <Label className='form-label' for='login-email'> Email </Label>
                      <Controller
                        // id='empId'
                        // name='empId'
                        id='loginEmail'
                        name='loginEmail'
                        control={control}
                        render={({ field }) => (
                          <Input
                            autoFocus
                            type="email"
                            // className="email-class"
                            placeholder='john@example.com'
                            invalid={errors.loginEmail && true}
                            {...field}
                          />
                        )}
                      />
                    </div>
                    <div className='mb-1'>
                      <div className='d-flex justify-content-between'>
                        <Label className='form-label' for='login-password'>
                          Password
                        </Label>
                        <Link to="/forgot-password">
                          <small>Forgot Password?</small>
                        </Link>
                      </div>
                      <Controller
                        id='password'
                        name='password'
                        control={control}
                        render={({ field }) => (
                          <InputPasswordToggle className='input-group-merge' invalid={errors.password && true} {...field} />
                        )}
                      />
                    </div>
                    <Button type='submit' color='primary' disabled={loading} block> {loading && <Spinner className="me-1" size={'sm'}></Spinner>}
                      Sign in </Button>
                    <h6 className="font-small-3 text-center mt-1">Powered By <span className="fw-bolder text-primary">SmarterDealer</span></h6>
                  </Form>
                </Col>
              </Col>

            </Col>

          </Row>
        </div>
      )
        :
        <SpinnerComponent />
      }
    </>
  );
};

export default Login;
